import { Select } from "antd";
import { useSelector } from "react-redux";
import { selectAvailableClients } from "redux/slices/userSlice";

export const ClientSelector = ({
  value,
  onChange,
  disabled,
  placeholder = "Select Client",
  allowClear = true,
  showSearch = true,
  style,
  className,
  ...props
}) => {
  const filteredClients = useSelector(selectAvailableClients);

  const options = (filteredClients || []).map((client) => ({
    value: client.id,
    label: client.name,
  }));

  const handleChange = (selectedValue) => {
    if (!onChange) return;

    if (!selectedValue) {
      onChange(null);
      return;
    }

    onChange(selectedValue);
  };

  return (
    <Select
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      allowClear={allowClear}
      showSearch={showSearch}
      labelInValue
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      className={className}
      style={{ width: "100%", ...style }}
      {...props}
    />
  );
};
